import { LinearProgress } from "@material-ui/core";
import React from "react";
import { useGetExamSessionQuery } from "../../../api/rtk/ExamSessionApi";
import { ExamSessionCandidateViewModel } from "../../../model/examSessionCandidate/ExamSessionCandidateViewModel";
import ExamSessionCandidateModule from "./ExamSessionCandidateModule";
import { ExamSessionCandidateExamCallbacks } from "./ExamSessionCandidateExam";
import { ExamSessionCandidateModuleViewModel } from "../../../model/examSessionCandidate/ExamSessionCandidateModuleViewModel";
import { ExamType } from "../../../model/Exam";

interface ExamSessionCandidateModulesProps extends ExamSessionCandidateExamCallbacks {
  examSessionCandidate: ExamSessionCandidateViewModel;
  moduleId: string;
  onCancelModule: (module: ExamSessionCandidateModuleViewModel) => void;
  onRebookModule: (module: ExamSessionCandidateModuleViewModel, rebookWithInvoice: boolean) => void;
  onAddExam: (moduleId: string, examId: string, examType: ExamType) => void;
}

const ExamSessionCandidateModules: React.FunctionComponent<ExamSessionCandidateModulesProps> = ({
  examSessionCandidate,
  moduleId,
  onCancelModule,
  onRebookModule,
  onAddExam,
  ...callbacks
}) => {
  const { data: examSession, isFetching } = useGetExamSessionQuery(examSessionCandidate.examSessionId);
  const exams = examSessionCandidate?.exams.filter((exam) => exam.moduleId === moduleId);

  const modules = examSessionCandidate.modules;

  const handleAddExam = (moduleId: string, examId: string) => {
    const exam = examSession?.exams.find((e) => e.id === examId);
    if (exam){
      onAddExam(moduleId, examId, exam.type);
    }
  }

  return (
    <>
      {isFetching && <LinearProgress variant="query" />}
      {!isFetching &&
        examSession !== undefined &&
        modules.filter(m => m.moduleId === moduleId).map((module) => (
          <ExamSessionCandidateModule
            key={module.moduleId}
            module={module}
            exams={exams.filter((e) => e.moduleId === module.moduleId)}
            examSession={examSession}
            examSessionCandidate={examSessionCandidate}
            onCancelModule={onCancelModule}
            onRebookModule={onRebookModule}
            onAddExam={handleAddExam}
            {...callbacks}
          />
        ))}
    </>
  );
};

export default ExamSessionCandidateModules;
